import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import ImageCropper from './ImageCropper';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const Register = () => {
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [gender, setGender] = useState('');
    const [photo, setPhoto] = useState(null);
    const [showCropper, setShowCropper] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(null);
    const [isRegistering, setIsRegistering] = useState(false);
    const [registerMsg, setRegisterMsg] = useState('');
    const navigate = useNavigate();

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (ev) => {
                setImageToCrop(ev.target.result);
                setShowCropper(true);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleCropComplete = (croppedBlob) => {
        setPhoto(croppedBlob);
        setShowCropper(false);
        setImageToCrop(null);
    };

    const handleCropCancel = () => {
        setShowCropper(false);
        setImageToCrop(null);
    };

    const handleRegister = () => {
        setIsRegistering(true);
        setRegisterMsg(photo ? 'Your UMA is being prepared for IKOBU Station. Image processing may take up to a minute. Please be patient!' : 'Registering UMA...');
        // Assign a callback to run when reCAPTCHA returns a token.
        window.onCaptchaSuccess = function (token) {
            console.log('✔️ reCAPTCHA token received:', token);
            const formData = new FormData();
            formData.append('email', email);
            formData.append('username', username);
            formData.append('password', password);
            formData.append('gender', gender);
            formData.append('captchaToken', token);
            if (photo) {
                formData.append('photo', photo, 'profile.jpg');
            }
            api.post('/users/signup', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then(() => navigate('/login'))
                .catch(err => {
                    setRegisterMsg(err.response?.data?.error || err.message || 'Registration failed!');
                    setIsRegistering(false);
                });
        };
        // Execute the invisible reCAPTCHA.
        window.grecaptcha.execute();
    };

    return (
        <div className="terminal min-h-screen flex items-center justify-center font-mono text-green-300 px-4">
            <div className="w-full max-w-md p-6 border border-green-500 bg-black rounded-md shadow-lg">
                <h2 className="text-xl text-green-400 mb-4 text-center">umaREGISTER</h2>

                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    required
                    className="input-terminal mb-3"
                />

                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    className="input-terminal mb-3"
                />

                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                    className="input-terminal mb-3"
                />

                <label className="block mb-3">
                    Gender:
                    <select
                        value={gender}
                        onChange={e => setGender(e.target.value)}
                        required
                        className="input-terminal"
                        style={{ color: gender ? "#fff" : "#888" }}
                    >
                        <option value="" disabled hidden>
                            Select your gender...
                        </option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="unspecified">Unspecified</option>
                    </select>
                </label>

                <label htmlFor="profile-photo-upload" className="block mb-2">
                    Profile Photo
                    <span
                        data-tooltip-id="profile-photo-tip"
                        data-tooltip-content="Upload a clear, well-lit photo of your face (no sunglasses or hats). Use a square image, at least 1024x1024px, for best AI results. Backgrounds don't matter—AI will place you on IKOBU Station!"
                        className="ml-2 cursor-pointer text-green-400"
                        style={{ fontWeight: 'bold', fontSize: '1.2em' }}
                    >
                        ⓘ
                    </span>
                </label>
                <input
                    id="profile-photo-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="input-terminal mb-6"
                />
                <Tooltip id="profile-photo-tip" place="top" />

                <button onClick={handleRegister} className="btn-primary w-full mb-3" disabled={isRegistering}>
                    {isRegistering ? 'Registering...' : 'Register UMA with IKOBU Station'}
                </button>
                {registerMsg && (
                    <div className="text-yellow-400 text-xs mb-3 text-center">{registerMsg}</div>
                )}

                <hr className="border-green-800 my-4" />

                <button onClick={() => navigate('/login')} className="btn-secondary w-full">
                    umaFILE on Station? Uplink Here
                </button>
            </div>
            {showCropper && imageToCrop && (
                <ImageCropper
                    imageSrc={imageToCrop}
                    onCropComplete={handleCropComplete}
                    onCancel={handleCropCancel}
                    aspect={1}
                />
            )}
        </div>
    );
};

export default Register;